import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const TreePalm = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          d="M15.214 10.188c1.67.593 2.535 2.405 1.923 4.045a.667.667 0 01-1.272-.392l.023-.074c.35-.937-.147-1.977-1.12-2.322a1.918 1.918 0 00-2.102.558l.001 2.694a9.686 9.686 0 00.08.948c.099.75.278 1.497.555 2.187.165.413.36.792.586 1.132a.667.667 0 01-1.11.74 7.483 7.483 0 01-.714-1.376 10.502 10.502 0 01-.64-2.507l-.038-.324a8.824 8.824 0 01-.052-.744v-2.75a1.918 1.918 0 00-2.102-.558c-.935.332-1.43 1.306-1.157 2.213l.037.109a.667.667 0 01-1.25.466c-.611-1.64.255-3.451 1.924-4.045a3.259 3.259 0 013.215.6c.859-.745 2.086-1 3.213-.6zm1.713-2.575c2.423.876 3.673 3.54 2.79 5.95a.667.667 0 01-1.252-.459 3.3 3.3 0 00-1.991-4.237c-1.641-.594-3.17-.285-3.918.84l-.013.019a.661.661 0 01-.038.048l.05-.067a.67.67 0 01-.186.187l-.022.014a.665.665 0 01-.048.026l.07-.04a.67.67 0 01-.219.094l-.038.007a.531.531 0 01-.074.01h-.02a.54.54 0 01-.076-.002l-.038-.005a.496.496 0 01-.059-.01c-.013-.005-.026-.008-.04-.012a.529.529 0 01-.067-.024l-.023-.012a.537.537 0 01-.077-.041c-.001-.003-.004-.004-.007-.006a.56.56 0 01-.074-.056l.074.056a.67.67 0 01-.146-.13l-.02-.028a.285.285 0 01-.02-.027c-.749-1.125-2.277-1.434-3.918-.841a3.3 3.3 0 00-1.992 4.237.667.667 0 01-1.252.459c-.883-2.41.368-5.074 2.79-5.95 1.854-.67 3.72-.445 4.927.697 1.208-1.142 3.073-1.368 4.927-.697zm1.585-2.028a.667.667 0 11-1.024.854 3.064 3.064 0 00-3.15-1A3.044 3.044 0 0012.56 6.74l-.017.026a.662.662 0 01-.037.048l.054-.074a.67.67 0 01-.199.2l-.011.007a.665.665 0 01-.062.034l.073-.041a.67.67 0 01-.71.008l-.012-.008-.024-.016a.662.662 0 01-.05-.039l.074.055a.67.67 0 01-.2-.2A3.044 3.044 0 009.662 5.44a3.063 3.063 0 00-3.149 1 .667.667 0 11-1.024-.854A4.396 4.396 0 0112 5.316a4.352 4.352 0 011.993-1.165 4.397 4.397 0 014.518 1.434z"
          id="treepalm-line-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="treepalm-line-b" fill="#fff">
          <use xlinkHref="#treepalm-line-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#treepalm-line-a" />
        <g
          mask="url(#treepalm-line-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M19.983 13.333c.186-2.546-1.167-5.05-3.556-6.139a5.815 5.815 0 00-.88-.312l3.12-1.282c-1.212-1.402-3.192-1.993-4.978-1.325A4.154 4.154 0 0012 5.466a4.16 4.16 0 00-1.69-1.191C8.526 3.607 6.546 4.198 5.334 5.6l3.12 1.282c-.296.081-.59.18-.879.312-2.39 1.089-3.742 3.593-3.557 6.14L6 12.504v-1.172l1.277.639 1.39-.58V10l1.979.565.02-.008v2.11h.012c-.065 1.901.228 4.415 1.322 7.333h4c-2.667-3.333-2.667-7.333-2.667-7.333v-2.11l.021.008 1.98-.565v1.392l1.389.58L18 11.333v1.172l1.983.828z"
          id="treepalm-solid-a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="treepalm-solid-b" fill="#fff">
          <use xlinkHref="#treepalm-solid-a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#treepalm-solid-a" />
        <g
          mask="url(#treepalm-solid-b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
